import {
    showOrderItemAddressSelectionDisplay
} from './_showOrderItemAddressSelectionDisplay';
import {
	showOrderItemShipModeSelectionDisplay
} from './_showOrderItemShipModeSelectionDisplay';
import {
	showGlobalShipModeDisplay
} from './_showGlobalShipModeDisplay';
import {
	showStorePickupTopDisplay
} from './_showStorePickupTopDisplay';
import {
	showStorePickupHeader
} from './_showStorePickupHeader';

export const allDevicesDisplayMultiShip = () => {
    $('#displayMultiShipRadio').on('change', function(event) {
    	showOrderItemAddressSelectionDisplay(true);
        showOrderItemShipModeSelectionDisplay(true);
        showGlobalShipModeDisplay(false);

    });
};
